import { PosterTextSet } from './qr-poster-texts.model';
import { QrPosterTemplate } from './qr-poster-template.model';
import type { QrPosterColorizedIconAssetName } from './qr-poster-icons.model';

export type QrPosterRenderLanguage = 'de' | 'en';
export const CANONICAL_QR_POSTER_RENDERER_VERSION = 'canonical-qr-poster-v2';

export interface QrPosterRenderDescriptor {
  rendererVersion: typeof CANONICAL_QR_POSTER_RENDERER_VERSION;
  templateSource: 'custom' | 'default';
  templateDisplayName: string | null;
  template: QrPosterTemplate;
  renderLanguage: QrPosterRenderLanguage;
  posterTexts: PosterTextSet;
  branding: {
    companyName: string;
    companyDisplayEmail: string;
    companyPhone: string;
    companyWebsite: string;
    companyAddress: string;
    themeColor: string;
    footerEnabled: boolean;
  };
  property: {
    propertyId: string;
    propertyAddress: string;
  };
  qrDestination: string;
  templateImageAssetKeys: string[];
}

export interface QrPosterRenderDescriptorResponse {
  descriptor: QrPosterRenderDescriptor;
}

export interface QrPosterIconAssets extends Partial<Record<QrPosterColorizedIconAssetName, string>> {
  [iconName: string]: string | undefined;
}

export interface PreparedQrPosterAssets {
  template: QrPosterTemplate;
  logoBase64: string;
  icons: QrPosterIconAssets;
  dispose(): void;
}
